import { render, staticRenderFns } from "./HeaderProductShowcase.vue?vue&type=template&id=5853aed8&"
import script from "./HeaderProductShowcase.vue?vue&type=script&lang=js&"
export * from "./HeaderProductShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports